import {getBreakpoint} from "@front/utils";
import {createComponent} from "@front/utils/alpine";
import Swiper, {Navigation, SwiperOptions, EffectFade, Thumbs} from "swiper";

const imagesSlider = createComponent(() => ({
    init() {

        if (!this.$refs.nav || !this.$refs.cover) {
            //console.warn('References not found for the slider');
            return;
        }

        if (this.$refs.nav.querySelectorAll('.thumb-container').length === 0) {
            //console.warn('No images found for the slider');
            return;
        }

        const navConfig: SwiperOptions = {
            modules: [Navigation],
            navigation: {
                prevEl: this.$refs.navPrev,
                nextEl: this.$refs.navNext,
            },
            slidesPerView: 4,
            spaceBetween: 6,
            slideToClickedSlide: true,
            watchSlidesProgress: true,
            breakpoints: {
                [getBreakpoint('sm')]: {
                    slidesPerView: 5,
                },
                [getBreakpoint('md')]: {
                    slidesPerView: 3,
                },
                [getBreakpoint('lg')]: {
                    slidesPerView: 4,
                },
                [getBreakpoint('xl')]: {
                    slidesPerView: 5,
                }
            }
        }

        const thumbsSwiper = new Swiper(this.$refs.nav, navConfig);

        const coverConfig: SwiperOptions = {
            modules: [EffectFade,Navigation,Thumbs],
            //slideToClickedSlide: true,
            slidesPerView: 1,
            effect: 'fade',
            fadeEffect: {
                crossFade: true,
            },
            loop: true,
            thumbs: {
                swiper: thumbsSwiper,
                slideThumbActiveClass: 'swiper-slide-thumb-active',
            },
            on : {
                init: function() {
                    thumbsSwiper.slideTo(0);
                },
                slideChange: function (swiper) {
                    const activeIndex = swiper.realIndex;
                    thumbsSwiper.slideTo(activeIndex);
                }
            }
        }

        const mainSwiper = new Swiper(this.$refs.cover, coverConfig);

        const thumbs = this.$refs.nav.querySelectorAll('.thumb-container');
        thumbs.forEach((thumb, index) => {
            thumb.addEventListener('click', () => {
                mainSwiper.slideToLoop(index);
            });
        });

    },
}));

export const productSticky = createComponent(() => ({
    fixed: false,
    bottomFixed: false,
    startPos: 0,
    endPos: 0,
    stickyHeight: 0,
    parentHeight: 0,
    resizeScheduled: false,

    init() {
        const { stickyCol, firstCol } = (this as any).$refs as {
            stickyCol: HTMLElement;
            firstCol: HTMLElement;
        };

        const recalcDimensions = () => {
            // get dimensions parent
            const parentRect = firstCol.getBoundingClientRect();
            this.parentHeight = parentRect.height;

            this.stickyHeight = stickyCol.offsetHeight;

            const headerOffset = 80;
            this.startPos = parentRect.top + window.scrollY - headerOffset;

            this.endPos = this.startPos + (this.parentHeight - this.stickyHeight);

            const parentWidth = firstCol.offsetWidth;
            const maxWidth = Math.min(613, parentWidth);
            stickyCol.style.width = `${maxWidth}px`;
        };

        recalcDimensions();

        const resizeObserver = new ResizeObserver(() => {
            if (!this.resizeScheduled) {
                this.resizeScheduled = true;
                requestAnimationFrame(() => {
                    recalcDimensions();
                    // Forzar actualización del estado
                    this.onScroll();
                    this.resizeScheduled = false;
                });
            }
        });
        resizeObserver.observe(firstCol);

        window.addEventListener('resize', () => {
            if (!this.resizeScheduled) {
                this.resizeScheduled = true;
                requestAnimationFrame(() => {
                    recalcDimensions();
                    this.onScroll();
                    this.resizeScheduled = false;
                });
            }
        });
    },

    onScroll() {
        const scrollY = window.scrollY;
        const viewportHeight = window.innerHeight;

        if (scrollY < this.startPos) {
            this.fixed = false;
            this.bottomFixed = false;
        } else if (scrollY >= this.endPos) {
            this.fixed = false;
            this.bottomFixed = true;
        } else {
            this.fixed = true;
            this.bottomFixed = false;
        }
    },
}));



function toggleModal(force: boolean) {
    document.body.classList.toggle('overflow-y-hidden', force);
    document.body.classList.toggle('h-[100vh]', force);
    document.querySelector('#main')?.classList.toggle('relative', force);
    document.querySelector('#main')?.classList.toggle('z-[1001]', force);
}

const modal = createComponent(() => ({
    isOpened: false,

    toggle(force: boolean) {
        this.isOpened = force == undefined ? !this.isOpened : force;
    },

    setup() {
        const covers = document.querySelectorAll('.js-customer-img');
        const modalPicture = document.querySelector('.js-customer-modal-picture') as HTMLImageElement;
        const modalCaption = document.querySelector('.js-customer-modal-caption') as HTMLElement;

        toggleModal(this.isOpened);
        this.$watch('isOpened', toggleModal);

        covers.forEach((item) => {
            item.addEventListener('click', (e) => {
                const el = e.target as HTMLImageElement;
                modalPicture.src = el.src;
                modalPicture.alt = el.alt;
                modalCaption.innerHTML = el.alt;

                toggleModal(true);
                this.toggle(true);
            });
        });
    },
}));

const modalCart = createComponent(() => ({
    setup() {
        const modalCart = document.querySelector('.js-product-modal') as HTMLElement;

        document.addEventListener('click', (e) => {
            const target = e.target as HTMLElement;
            const isModal = target.closest('.js-product-modal-inner') as HTMLElement;

            if (!isModal && modalCart.classList.contains('!visible')) {
                modalCart.classList.remove('!visible', '!opacity-100', '!pointer-events-auto');
            }
        });
    }
}));




const photosSlider = createComponent(() => ({
    init() {


        if (!this.$refs.photos) {
            console.warn('References not found for the photo slider');
            return;
        }

        const photoConfig: SwiperOptions = {
            modules: [Navigation],
            navigation: {
                prevEl: this.$refs.photosPrev,
                nextEl: this.$refs.photosNext,
            },
            slidesPerView: 2,
            spaceBetween: 15,
            slideToClickedSlide: true,
            watchSlidesProgress: false,
            breakpoints: {
                [getBreakpoint('sm')]: {
                    slidesPerView: 2,
                },
                [getBreakpoint('md')]: {
                    slidesPerView: 2,
                },
                [getBreakpoint('lg')]: {
                    slidesPerView: 4,
                },
                [getBreakpoint('xl')]: {
                    slidesPerView: 4,
                }
            }
        }

        new Swiper(this.$refs.photos, photoConfig);},
}));


export default {
    photosSlider,
    imagesSlider,
    productSticky,
    modal,
    modalCart,
};